export const PATHS = {
  form: {
    htmlPath: '/assets/widgets/new-form.html',
    jsPath: '/assets/js/form-tracking.js',
  },
  publicPath: '/public/v2/form',
  cliffHanger: {
    htmlPath: '/assets/integration.html',
    jsdevPath: '/assets/js/integration-dev.js',
    jsPath: '/assets/js/integration.js',
  },
  selfAssessment: {
    htmlPath: '/selfassessment',
  },
  dentalAssessment: {
    htmlPath: '/assets/static/composer.html',
  },
};
